import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const spreadsheetImages: Record<string, string> = import.meta.glob('@/assets/landing/spreadsheet/*.png', {
	eager: true,
	import: 'default',
})

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'creatives_spreadsheet',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_funnel.pages.landing.title_spreadsheet'),
			size: 'large',
			uppercase: true,
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			const img =
				Object.entries(spreadsheetImages).find(([k]) => k.includes(`${ctx.language}.png`))?.[1] ??
				Object.entries(spreadsheetImages).find(([k]) => k.includes('en.png'))?.[1]

			return { img }
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
